import {
	CONDITION_OPERATORS,
	ENGINE_EVALUATIONS,
	ENGINE_TYPES
} from "../screens/rule-provider/constants.js";

export function hasSectionCountRule(rule) {
	return rule.Engine?.Code === "DETAILS:COUNT" || (rule.Children ?? []).some(hasSectionCountRule);
}

export function hasDetailCondition(rule, fields) {
	if(rule.Children?.length) {
		return rule.Children.some(child => hasDetailCondition(child, fields));
	}
	if(ENGINE_TYPES[rule.Engine?.Code]?.isAggregate) {
		return false;
	}
	return (rule.Conditions ?? []).some(condition => [condition.Field?.Id, condition.CompareToField?.Id]
		.some(id => id != null && fields.some(field => field.Id === id && field.IsDetail)));
}

export function isParentSectionCountRule(rule, fields) {
	return hasSectionCountRule(rule) && !hasDetailCondition(rule, fields);
}

export function prepareDetailsCountCondition(rule) {
	if(!Array.isArray(rule.Conditions) || rule.Conditions.length !== 1) {
		throw new Error("DETAILS:COUNT requires exactly one condition.");
	}
	const condition = rule.Conditions[0];
	const evaluator = ENGINE_EVALUATIONS.compare[CONDITION_OPERATORS[condition?.Operator?.Code]];
	const value = condition?.Value;
	if(typeof evaluator !== "function"
		|| (typeof value !== "number" && typeof value !== "string")
		|| (typeof value === "string" && value.trim() === "") || !Number.isFinite(Number(value))
		|| [condition.Field, condition.Scope, condition.CompareToField, condition.MinValue, condition.MaxValue].some(option => option != null)) {
		throw new Error("DETAILS:COUNT requires a numeric COMPARE condition without field, scope, or range options.");
	}
	return { evaluator, value: Number(value) };
}
